import { useEffect, useState } from 'react';
import { authGet } from '../../../services/apiService';

const PROBLEMS_URL = '/api/incident-remediation/problems';

// One request: the API returns every stored Problem. If it says the list was cut short, fail loudly --
// a partial report would silently misstate the counts. The start date comes from the server, which owns it.
const fetchProblems = async () => {
  const response = await authGet(PROBLEMS_URL, null, 'json', { useCache: false });
  if (!response.success) throw new Error(response.message || 'Failed to load problems');
  if (response.truncated) throw new Error('Too many problems to load; the report would be incomplete.');
  if (!response.reportStart) throw new Error('The server did not send the report start date.');
  return {
    problems: Array.isArray(response.problems) ? response.problems : [],
    reportStart: response.reportStart
  };
};

/**
 * Loads the Problems for the report. Owns the API call for the page, so the components only render.
 * data is null until the load succeeds.
 */
export const useIncidentRemediation = () => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    let mounted = true;
    fetchProblems()
      .then((result) => {
        if (mounted) setData(result);
      })
      .catch((err) => {
        if (mounted) setError(err.message || 'Failed to load problems');
      })
      .finally(() => {
        if (mounted) setLoading(false);
      });
    return () => {
      mounted = false;
    };
  }, []);

  return { data, loading, error };
};
